import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import InnerWrapper from '../../../global/InnerWrapper';
import P from '../../../global/typography/P';
import Heading from './Heading';

import { swatches, media } from '../../../../styles/theme';

const TabletBreakpoint = media.tablet;
const MobileBreakpoint = '(max-width: 700px)';

const ContentWrapper = styled.div`
  display: flex;

  @media ${MobileBreakpoint} {
    flex-direction: column;
  }
`;

const List = styled.ul`
  list-style: none;

  @media ${MobileBreakpoint} {
    align-self: auto;
    width: auto;
    margin: 12px 0 0;
  }
`;

const ListItem = styled(P)`
  margin-bottom: 9px;
  color: ${swatches.white};
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    padding-right: 30px;
    position: absolute;
    display: inline-block;
    top: 6px;
    right: 100%;
    height: 12px;
    width: 14px;
    content: '';
    background-image: url('/customProduct/CustomArrows.png');
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

const Logo = styled.img`
  display: block;
  max-width: 500px;
  width: 90%;

  @media ${MobileBreakpoint} {
    margin: 0 auto;
  }
`;

const Paragraph = styled(P)`
  color: ${swatches.offwhite};
  margin-bottom: 20px;
`;

const ParagraphWrapper = styled.div`
  margin-right: 10vw;
  width: 50vw;

  @media ${MobileBreakpoint} {
    margin-right: 0;
    width: auto;
  }
`;

const RedHighlight = styled.span`
  color: ${swatches.primary};
`;

const SectionHeading = styled(Heading)`
  @media ${TabletBreakpoint} {
    font-size: 18px;
    font-weight: 800;
  }
`;

const Wrapper = styled.section`
  background-color: ${swatches.gray.dark};
  padding: 60px 0;

  @media ${MobileBreakpoint} {
    padding: 20px 0;
  }
`;

const SmartX = ({ className, heading, image, list, paragraph }) => (
  <Wrapper image={image} className={className}>
    <InnerWrapper>
      <SectionHeading>
        Smart <RedHighlight>{heading}</RedHighlight>
      </SectionHeading>
      <ContentWrapper>
        <ParagraphWrapper>
          <Paragraph>{paragraph}</Paragraph>
          <Logo src={image} alt="Smart Control Logo" />
        </ParagraphWrapper>
        <List>
          {list.map((li, i) => (
            <ListItem key={i}>{li}</ListItem>
          ))}
        </List>
      </ContentWrapper>
    </InnerWrapper>
  </Wrapper>
);

SmartX.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.string),
  paragraph: PropTypes.string.isRequired
};

export default SmartX;
